import { GraphRest } from "../rest.js";
import { DirectoryObjects } from "./types.js";
export { DirectoryObjectTypes, DirectoryObject, DirectoryObjects, } from "./types.js";
Reflect.defineProperty(GraphRest.prototype, "directoryObjects", {
    configurable: true,
    enumerable: true,
    get: function () {
        return this.childConfigHook(function (_a) {
            var options = _a.options, baseUrl = _a.baseUrl, runtime = _a.runtime;
            return DirectoryObjects(baseUrl).configure(options).setRuntime(runtime);
        });
    },
});
//# sourceMappingURL=index.js.map